import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const FinancialManage: AppRouteModule = {
  path: '/financialManage',
  name: 'FinancialManage',
  component: LAYOUT,
  redirect: '/financialManage/receiptManage',
  identify: 'financialManage',
  meta: {
    icon: 'icon-park-outline:finance',
    title: '财务管理',
    orderNo: 1,
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    // 收款管理
    {
      path: 'receiptManage',
      name: 'ReceiptManage',
      component: () => import('@/views/financialManage/receiptManage/index.vue'),
      identify: 'receiptManage',
      meta: {
        title: '收款管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 付款管理
    {
      path: 'paymentManage',
      name: 'PaymentManage',
      component: () => import('@/views/financialManage/paymentManage/index.vue'),
      identify: 'paymentManage',
      meta: {
        title: '付款管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 采购往来
    {
      path: 'purchaseContact',
      name: 'PurchaseContact',
      component: () => import('@/views/financialManage/purchaseContact/index.vue'),
      identify: 'purchaseContact',
      meta: {
        title: '采购往来',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 配销往来
    {
      path: 'wholesaleContact',
      name: 'WholesaleContact',
      component: () => import('@/views/financialManage/wholesaleContact/index.vue'),
      identify: 'wholesaleContact',
      meta: {
        title: '配销往来',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'wholesaleContactDetail',
      name: 'WholesaleContactDetail',
      component: () => import('@/views/financialManage/wholesaleContact/detail.vue'),
      identify: 'wholesaleContact',
      meta: {
        title: '配销往来详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/financialManage/wholesaleContact',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default FinancialManage;
